import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/index'
import firebase from 'firebase/app'
import VueGtag from 'vue-gtag'

// Development mode
if (location.hostname.match(/(rach.kings.kucits.ca)|(tomo.kings.kucits.ca)/gi)) {
  Vue.config.devtools = true
  Vue.config.productionTip = false
}else {
  // Production
  Vue.use(VueGtag, {
    config: {
      id: "G-MHXY7Z9ZCD" 
    },
    appName: 'cupe-app',
    pageTrackerScreenviewEnabled: true
  }, router);
}

const firebaseConfig = {
  apiKey: "AIzaSyAB4fMe_rqVPEQ-DnbGBPqiT504A-FveWw",
  authDomain: "cupe-app.firebaseapp.com",
  projectId: "cupe-app",
  storageBucket: "cupe-app.appspot.com",
  messagingSenderId: "558658842582",
  appId: "1:558658842582:web:4b976191bc021cc7debe77",
  measurementId: "G-MHXY7Z9ZCD"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
